import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components';
import { EditIcon } from '~/icons';
import { SmallTrashIcon } from '~/icons/Trash';
import { colors } from '~/styles/colors';
import { Sidebar, WeekDayButton } from '../../../styles';
import { Schedule } from '../../types';
import { DamSchedContainer, DaysContainer, Title } from './styles';

interface DamScheduleViewCardProps {
  schedule: Schedule;
  onDelete: () => void;
  onEdit: () => void;
  hide?: {
    edit: boolean;
    delete: boolean;
  }
  loading?: boolean;
}

export function DamScheduleViewCard({
  hide,
  schedule,
  loading,
  onDelete,
  onEdit,
}: Readonly<DamScheduleViewCardProps>): ReactElement {
  const {
    beginTime, days, title, endTime, permission, status,
  } = schedule;
  const active = status ? '1' : '0';
  const { t } = useTranslation();

  return (
    <DamSchedContainer size="small">
      <Sidebar active={active} />
      <div style={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        width: '334px',
      }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Title>{title}</Title>
            <div style={{ display: 'flex' }}>
              {!hide?.edit && (
                <Button
                  style={{
                    border: '0px',
                    backgroundColor: 'white',
                    padding: '0px',
                    marginRight: '5px',
                    width: 'fit-content',
                  }}
                  onClick={onEdit}
                  disabled={loading}
                >
                  <EditIcon color={loading ? 'grey' : colors.Blue300} />
                </Button>
              )}
              {!hide?.delete && (
                <Button
                  style={{
                    border: '0px',
                    backgroundColor: 'white',
                    padding: '0px',
                    width: 'fit-content',
                  }}
                  onClick={onDelete}
                  disabled={loading}
                >
                  <SmallTrashIcon color={loading ? 'grey' : 'red'} />
                </Button>
              )}
            </div>
          </div>
        </div>

        <div style={{
          width: '100%',
          height: '1px',
          backgroundColor: colors.LightGrey_v3,
          borderRadius: '10px',
          margin: '20px 0px 20px 0px',
        }}
        />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontWeight: 'bold' }}>{t('funcionamento')}</div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>{permission === 'allow' ? t('ligado') : t('desligado')}</div>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div>
                  <span style={{ fontWeight: 'bold' }}>
                    {t('horarioDeInicio')}
                    :&nbsp;
                  </span>
                  <span>
                    {beginTime}
                  </span>
                </div>
                <div>
                  <span style={{ fontWeight: 'bold' }}>
                    {t('horarioDeFim')}
                    :&nbsp;
                  </span>
                  <span>
                    {endTime}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: '10px' }}>
          {days && (
          <DaysContainer>
            <WeekDayButton checked={days.sun} status={active} size="small">DOM</WeekDayButton>
            <WeekDayButton checked={days.mon} status={active} size="small">SEG</WeekDayButton>
            <WeekDayButton checked={days.tue} status={active} size="small">TER</WeekDayButton>
            <WeekDayButton checked={days.wed} status={active} size="small">QUA</WeekDayButton>
            <WeekDayButton checked={days.thu} status={active} size="small">QUI</WeekDayButton>
            <WeekDayButton checked={days.fri} status={active} size="small">SEX</WeekDayButton>
            <WeekDayButton checked={days.sat} status={active} size="small">SAB</WeekDayButton>
          </DaysContainer>
          )}
        </div>
      </div>
    </DamSchedContainer>
  );
}
